import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ShopItemActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/ShopItemImport/ShopItemImportForm")
	}

	render() {
		return (
			<Activity 
				name="ShopItemImport"
				RenderedComponent={this.RenderedComponent}
				context="ShopClothImport"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ShopItemActivity)
